module.exports = __webpack_public_path__ + "img/info.e002a780.svg";